import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  overlay: {
    width: "100%",
    "& .MuiDialog-root": {
      left: 0,
      top: 0,
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        left: theme.widthTabletDrawer,
        top: theme.heightDesktopHeader
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        left: theme.widthDesktopDrawer,
        top: theme.heightDesktopHeader
      }
    },
    "& .MuiBackdrop-root": {
      top: theme.heightDesktopHeader,
      left: theme.widthTabletDrawer,
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        top: theme.heightDesktopHeader,
        left: theme.widthDesktopDrawer
      }
    },
    "& .MuiDialogContent-root": {
      padding: "4px 0"
    },
    "& .MuiDialog-container": {
      width: "100%",
      borderLeft: `1px solid ${theme.palette.text.hint}`
    },
    "& .MuiDialog-paper": {
      margin: 0,
      width: "100%",
      height: "100%",
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        width: `calc(100% - ${theme.widthTabletDrawer}px)`
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        width: `calc(100% - ${theme.widthDesktopDrawer}px)`
      }
    },
    "& .MuiDialog-paperWidthFalse": {
      maxWidth: "100%",
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        width: `calc(100% - ${theme.widthTabletDrawer}px)`
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        maxWidth: `calc(100% - ${theme.widthDesktopDrawer}px)`
      }
    },
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "100%",
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        width: `calc(100% - ${theme.widthTabletDrawer}px)`
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        maxWidth: `calc(100% - ${theme.widthDesktopDrawer}px)`
      }
    },
    "& .MuiDialog-paperScrollPaper": {
      maxHeight: "100%"
    },
    "& .MuiDialog-scrollPaper": {
      alignItems: "flex-start",
      justifyContent: "flex-start"
    },
    "& .MuiPaper-rounded": {
      borderRadius: 0
    },
    "& .MuiPaper-elevation24": {
      boxShadow: "none"
    },
    "& .MuiDialogTitle-root": {
      display: "flex",
      flexDirection: "column",
      padding: "4px 24px",
      minHeight: 56,
      alignItems: "center"
    },
    //Title style
    "& .MuiTypography-h6": {
      alignSelf: "center",
      fontSize: 16,
      fontFamily: "SuisseIntlMedium"
    },
    //Subtitle style
    "& .MuiTypography-caption": {
      alignSelf: "center",
      fontSize: 14,
      color: theme.palette.text.secondary,
      textTransform: "capitalize"
    },
    "& .MuiDialogContent-dividers": {
      borderTop: `1px solid ${theme.palette.text.hint}`,
      borderBottom: "none"
    }
  },
  formContent: {
    justifyContent: "center",
    "& .MuiFormControl-root": {
      "& .MuiFormHelperText-root": {
        marginTop: 2
      },
      "& .MuiFormHelperText-contained": {
        fontSize: 9
      },
      "& .MuiOutlinedInput-root.Mui-focused": {
        "& fieldset": {
          borderColor: theme.palette.secondary.dark
        }
      },
      "& label.Mui-focused": {
        color: theme.palette.secondary.dark
      }
    },
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      padding: 0
    }
  },
  workOrderSection: {
    width: "100%",
    padding: "24px 16px",
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      padding: "24px 0"
    }
  },
  workOrderFieldLabel: {
    fontSize: 16,
    marginBottom: 12,
    width: "50%",
    color: theme.palette.text.primary
  },
  workOrderFieldTip: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    marginBottom: 12
  },
  workOrderTypeSelect: {
    width: "100%",
    height: 40,
    "& .MuiSelect-root": {
      fontSize: 14,
      color: theme.palette.text.primary
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      paddingTop: 10,
      paddingBottom: 10
    },
    "& .MuiSelect-icon": {
      fontSize: "1.7rem",
      top: "calc(50% - 14px)"
    },
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      width: "50%"
    }
  },
  formLabel: {
    top: -8,
    fontSize: 14
  },
  formSelectItem: {
    fontSize: 14,
    minHeight: 36
  },
  divider: {
    width: "100%",
    backgroundColor: "#dddddd"
  },
  dividerInvisible: {
    width: "100%",
    opacity: 0
  },
  textareaIssueDescription: {
    marginBottom: 20,
    "& .MuiOutlinedInput-root": {
      fontSize: 14
    },
    "& .MuiOutlinedInput-root fieldset": {
      borderColor: "#cbcbcb"
    },
    "& .MuiOutlinedInput-root:hover fieldset": {
      borderColor: "#cbcbcb"
    },
    "& .MuiFormHelperText-root $counter": {
      bottom: 5
    }
  },
  counter: {
    bottom: 13
  },
  counterRequired: {
    bottom: 30
  },
  autocomplete: {
    marginRight: 20,
    "& .MuiInputBase-root fieldset legend span": {
      paddingLeft: 2,
      paddingRight: 2
    },
    "& .MuiAutocomplete-inputRoot": {
      height: 40,
      width: 116,
      fontSize: 14,
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        width: 85
      }
    },
    "& .MuiInputLabel-outlined": {
      top: 2,
      fontSize: 14
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -7px) scale(0.68)"
    },
    "& .MuiOutlinedInput-inputMarginDense.MuiAutocomplete-input": {
      paddingTop: "5px !important",
      paddingLeft: "9px !important"
    },
    "& .MuiAutocomplete-popupIndicator": {
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        marginRight: -8
      }
    }
  },
  autocompletePopper: {
    boxShadow: "0px 0px 12px 0px rgb(0 0 0 / 40%)",
    top: "10px !important",
    fontSize: 14,
    borderRadius: 6,
    backgroundColor: "#fff",
    "& .MuiAutocomplete-option": {
      minHeight: 36
    }
  },
  autocompleteOption: {
    fontSize: 14,
    color: theme.palette.text.primary
  },
  autocompleteNoOptions: {
    fontSize: 14,
    padding: "2px 6px"
  },
  textFieldsRow: {
    display: "flex"
  },
  textFieldsContacts: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      flexDirection: "row"
    },
    "& .MuiFormControl-root": {
      marginBottom: 2
    }
  },
  stallTextField: {
    "& .MuiInputBase-root fieldset legend span": {
      padding: 0
    },
    "& .MuiOutlinedInput-input": {
      height: 40,
      width: 116,
      fontSize: 14,
      padding: "0 0 0 14px",
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        width: 85
      }
    },
    "& .MuiInputLabel-outlined": {
      top: -6,
      fontSize: 14
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, 1px) scale(0.68)"
    }
  },
  formControlContacts: {
    minHeight: 61,
    width: "100%",
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      width: "50%"
    },
    "& .MuiInputBase-root fieldset legend span": {
      padding: "0 4px 0 0"
    },
    "& .MuiOutlinedInput-root": {
      height: 40,
      fontSize: 14,
      padding: "0 0 0 8px",
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        width: "96%"
      }
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 0 10px 6px"
    },
    "& .MuiOutlinedInput-root:first-child": {
      [theme.breakpoints.up(Breakpoints.SM_600)]: {
        marginRight: 20
      }
    },
    "& .MuiInputLabel-outlined": {
      top: -6,
      fontSize: 14
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, 1px) scale(0.68)"
    },
    //style for email input
    "& + &": {
      "& .MuiFormControl-root.MuiTextField-root": {
        [theme.breakpoints.up(Breakpoints.SM_600)]: {
          marginLeft: "4%",
          width: "100%"
        }
      }
    }
  },
  numberInput: {
    width: "90%"
  },
  workOrderSectionButtons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 16px 24px",
    [theme.breakpoints.up(Breakpoints.XS_420)]: {
      justifyContent: "flex-end"
    },
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      padding: "0 0 24px 0"
    }
  },
  cancelButton: {
    marginRight: 14,
    height: 46,
    fontSize: 14,
    color: theme.palette.text.secondary,
    width: "40%",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    [theme.breakpoints.up(Breakpoints.XS_420)]: {
      fontSize: 16
    },
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      marginRight: 20,
      height: 38,
      width: 140,
      maxWidth: 140,
      minWidth: 0,
      fontSize: 14
    }
  },
  submitButton: {
    fontSize: 14,
    color: theme.palette.common.white,
    height: 46,
    width: "60%",
    fontFamily: "SuisseIntlRegular",
    backgroundColor: theme.palette.secondary.dark,
    border: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#7ad8b3"
    },
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
      backgroundColor: "#eeeeee",
      border: "none",
      "& .MuiTypography-root": {
        color: theme.palette.text.disabled
      }
    },
    "& .MuiCircularProgress-root": {
      color: theme.palette.common.white
    },
    [theme.breakpoints.up(Breakpoints.XS_420)]: {
      fontSize: 16
    },
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      fontSize: 14,
      color: theme.palette.common.white,
      height: 38,
      maxWidth: 204,
      width: 204,
      minWidth: 0
    }
  },
  discardDialog: {
    "& .MuiDialog-container": {
      [theme.breakpoints.up(Breakpoints.SX_720)]: {
        marginLeft: theme.widthTabletDrawer
      },
      [theme.breakpoints.up(Breakpoints.LG_1280)]: {
        marginLeft: theme.widthDesktopDrawer
      }
    },
    "& .MuiDialog-paperWidthSm": {
      width: 320
    },
    "& .MuiDialogContent-root": {
      fontSize: 14
    },
    "& .MuiDialogActions-root": {
      paddingRight: 19,
      paddingBottom: 7
    }
  },
  discardDialogTitle: {
    padding: "14px 24px 3px",
    "& h2": {
      fontSize: 20,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    }
  },
  buttonLeaveDiscard: {
    color: theme.palette.warning.dark,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  buttonStayContinue: {
    color: theme.palette.secondary.dark,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  },
  barnsLoader: {
    maxWidth: 85,
    height: 56,
    paddingLeft: 0,
    margin: 0,
    justifyContent: "left"
  },
  errorText: {
    color: theme.palette.error.main
  }
}));
